function Title() {
    return (<>
        <p className="title">
            header
        </p>
    </>);
}

export default Title;